import 'vendor/shared'

import '../controllers'

// Stylesheets
import '../assets/stylesheets/homepage.scss'

import Hex from '../homepage'
window.Hex = Hex